export default __webpack_public_path__ + "static/media/clock1.2aca11f6.gif";